import { VOUCHER_CAMPAIGN_PATH } from "@/shared/configs/routes.config";
import type { CampaignPurpose } from "@/shared/types/featureTeasing.types";

/** Where "Je charge moi-même" leads, per offer feature_code. No entry hides the button. */
export const SELF_SERVICE_PATHS: Partial<Record<string, string>> = { service_vouchers: VOUCHER_CAMPAIGN_PATH };

export const THANKS_MESSAGES = {
  upsell: "Votre intérêt a été enregistré. Votre responsable de compte reviendra vers vous.",
  activationWithAccountManager: "Votre demande a bien été transmise à votre AM.",
  activationWithoutAccountManager: "Votre demande a bien été enregistrée, notre équipe vous recontacte.",
} as const;

export const resolvePurpose = (purpose: string | null | undefined): CampaignPurpose =>
  purpose === "activation" ? "activation" : "upsell";

export const selfServicePath = (featureCode: string | null | undefined): string | undefined => {
  if (!featureCode || !Object.prototype.hasOwnProperty.call(SELF_SERVICE_PATHS, featureCode)) return undefined;
  return SELF_SERVICE_PATHS[featureCode];
};

export const thanksMessage = (purpose: CampaignPurpose, accountManagerAssigned: boolean): string => {
  if (purpose === "upsell") return THANKS_MESSAGES.upsell;
  return accountManagerAssigned
    ? THANKS_MESSAGES.activationWithAccountManager
    : THANKS_MESSAGES.activationWithoutAccountManager;
};
